var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-wrapper'),_c('div',{staticClass:"body-wrapper"},[_c('b-container',{staticClass:"full-sm"},[_c('router-view')],1)],1),_c('footer-wrapper')],1)}
var staticRenderFns = []

export { render, staticRenderFns }